import {
  AssetsApi,
  GenerateMixedVoiceoverRequest,
  GenerateMixedVoiceoverResponseFromJSON,
} from '@spotify-internal/ads-api-typescript-client-development';
import { useAdsApiInstance } from 'hooks/use-ads-api-instance';
import { useMutation } from '@tanstack/react-query';

export const useMixedVoiceOverMutation = (reactQuery = {}) => {
  // for mixed voice over request, we only use production api for now
  const mixedVoiceOverBaseUrl = 'https://api-partner.spotify.com/ads/v3';
  const { runApiRequest } = useAdsApiInstance(AssetsApi, mixedVoiceOverBaseUrl);

  return useMutation({
    ...reactQuery,
    mutationFn: async (request: GenerateMixedVoiceoverRequest) => {
      const {
        brandName,
        talkingPoints,
        aiVoiceoverTone,
        voiceProfileId,
        backgroundId,
      } = request;

      const requestParams = {
        method: 'generateMixedVoiceoverRaw',
        params: {
          generateMixedVoiceoverRequest: {
            brandName,
            talkingPoints,
            aiVoiceoverTone,
            voiceProfileId,
            backgroundId,
          },
        },
      };

      return runApiRequest(
        GenerateMixedVoiceoverResponseFromJSON,
        requestParams,
      );
    },
  });
};
